<mat-table *ngIf="dataSource" #table [dataSource]="dataSource" [@animateStagger]="{value:'50'}">

    <!-- Type Column -->
    <ng-container matColumnDef="icon">
        <mat-header-cell *matHeaderCellDef fxFlex="64px"></mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="64px">
            <mat-icon class="type-icon" [ngClass]="row.type"></mat-icon>
        </mat-cell>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef>Nome</mat-header-cell>      
        <mat-cell *matCellDef="let row"> 
            <mat-icon *ngIf="row.tipo == 'Voltar'">keyboard_backspace</mat-icon>
            {{row.name}}
        </mat-cell>
    </ng-container>

    <!-- Type Column -->
    <ng-container matColumnDef="type">
        <mat-header-cell *matHeaderCellDef fxHide fxShow.gt-md>Tipo</mat-header-cell>
        <mat-cell *matCellDef="let row" fxHide fxShow.gt-md>            
            {{ row.tipo == 'Voltar' ? '' : row.tipo}}
        </mat-cell>
    </ng-container>

    <!-- Owner Column -->
    <ng-container matColumnDef="owner">
        <mat-header-cell *matHeaderCellDef fxHide.xs>Proprietário</mat-header-cell>
        <mat-cell *matCellDef="let row" fxHide.xs> {{row.owner}}</mat-cell>
    </ng-container>

    <!-- Size Column -->
    <ng-container matColumnDef="size">
        <mat-header-cell *matHeaderCellDef fxHide.xs>Tamanho</mat-header-cell>
        <mat-cell *matCellDef="let row" fxHide.xs>{{row.size === '' ? '-': row.size}}</mat-cell>
    </ng-container>

    <!-- Modified Column -->
    <ng-container matColumnDef="modified">
        <mat-header-cell *matHeaderCellDef fxHide fxShow.gt-md>Modificado em</mat-header-cell>
        <mat-cell *matCellDef="let row" fxHide fxShow.gt-md>{{row.modified}}</mat-cell>
    </ng-container>

    <!-- Detail Button Column -->
    <ng-container matColumnDef="detail-button">
        <mat-header-cell *matHeaderCellDef fxFlex="48px" fxHide.gt-md></mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="48px" fxHide.gt-md>
            <button mat-icon-button class="sidebar-toggle" fxHide.gt-md
                    (click)="toggleSidebar('file-manager-details-sidebar')">
                <mat-icon class="secondary-text">info</mat-icon>
            </button>
        </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"
             (click)="onSelect(row)"
             (dblclick)="doubleClick(row)" 
             [ngClass]="{'selected' : row == selected}"             
             matRipple 
             [@animate]="{value:'*',params:{y:'100%'}}">
    </mat-row>
</mat-table>